export const checkMaxLength = async (value: string, maxLength: number): Promise<string> => {
  return value.length && value.length > maxLength
    ? `Maximum number of characters is ${maxLength}`
    : ''
}
